@if (isEpcotEnabled) {
    <div class="mybets-betslip-info_header" [ngClass]="{ 'mybets-result': hasResult }">
        @if (bet().betBuilderInfo) {
            <ms-my-bets-multi-bet-betbuilder-title [bet]="bet()" />
        } @else {
            @if (myBetsUtilService.isBetCardRedesigned()) {
                <ng-container [ngTemplateOutlet]="myBetsBetSlipHeadSectionRedesigned"></ng-container>
            } @else {
                <ng-container [ngTemplateOutlet]="myBetsBetSlipHeadSection"></ng-container>
            }
        }
    </div>
    @if (bet().betBuilderInfo) {
        <ms-my-bets-betbuilder-expanded-info
            class="mybets-betslip-multi-bet_betbuilder-expanded"
            [bet]="bet()"
            [event]="event()"
            [myBetsListContext]="myBetsListContext()"
            [cashedOut]="cashedOut()" />
    }
    <div class="mybets-betslip-info_details">
        <ng-container [ngTemplateOutlet]="myBetsBetSlipInfoSection"></ng-container>
    </div>
} @else {
    @if (bet().betBuilderInfo) {
        <ms-my-bets-multi-bet-betbuilder-title [bet]="bet()" />
        <ms-my-bets-betbuilder-expanded-info
            class="mybets-betslip-multi-bet_betbuilder-expanded"
            [bet]="bet()"
            [event]="event()"
            [myBetsListContext]="myBetsListContext()"
            [cashedOut]="cashedOut()" />
    } @else {
        <ng-container [ngTemplateOutlet]="myBetsBetSlipHeadSectionNonEpcot"></ng-container>
    }
    <ng-container [ngTemplateOutlet]="myBetsBetSlipInfoSection"></ng-container>
}

<ng-template #myBetsBetSlipHeadSectionRedesigned>
    @if (showBetslipId()) {
        <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip().betslipId }}</span>
    }
    <ng-content select="[mybets-non-event-info-betslip-headsection]" />
</ng-template>

<ng-template #myBetsBetSlipHeadSectionNonEpcot>
    <ng-container [ngTemplateOutlet]="TopRightSection" />
    <div [class.mybets-betslip-single-bet-header]="showBetslipId()">
        @if (showBetslipId()) {
            @if (!isEpcotEnabled) {
                <span class="mybets-betslip-single-bet-title bold highlight">{{ sitecoreMyBets.myBets.SingleBet }}</span>
            }
            <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip()?.betslipId }}</span>
        }
    </div>
    @if (showBetslipId()) {
        <div class="mybets-card-divider mybets-single-bet"></div>
    }
    <ng-container [ngTemplateOutlet]="pickInformation"></ng-container>
</ng-template>

<ng-template #myBetsBetSlipInfoSection>
    @if (hasResult()) {
        @if (isBetCardRedesign && bet().cancellationReason) {
            <div class="mybets-betslip-non-event-info_result_redesign">
                <span class="title_redesign">{{ sitecoreMyBets.myBets.CancellationReason }}</span>
                <span class="highlight_redesign">{{ bet().cancellationReason }}</span>
                @if (!myBetsListContext().isPrintView) {
                    <button ds-button-icon size="small" variant="flat-reduced" kind="tertiary" (click)="cancelledReasonHelp()">
                        <vn-icon name="theme-question" size="11" />
                    </button>
                }
            </div>
        } @else {
            <div class="mybets-betslip-non-event-info_result">
                @if (!isBetCardRedesign) {
                    <span class="title">{{
                        bet().cancellationReason ? sitecoreMyBets.myBets.CancellationReason : sitecoreMyBets.myBets.Results
                    }}</span>
                    <span class="highlight">{{ bet().cancellationReason ? bet().cancellationReason : bet().outcome }}</span>
                }
                @if (bet().cancellationReason && !myBetsListContext().isPrintView) {
                    <vn-icon class="event-info-question-icon" name="theme-question" size="12" (click)="cancelledReasonHelp()" />
                }
            </div>
        }
    }

    <ms-my-bets-betslip-scoreboard [bet]="bet()" [myBetsListContext]="myBetsListContext()" [cashedOut]="cashedOut()">
        <ng-container default>
            <div class="mybets-betslip-non-event-info_event-name highlight">
                @if (bet().isVirtual) {
                    @if (isEpcotEnabled) {
                        <vn-icon class="virtual-badge icon" size="14" [name]="'sports-' + bet().sportId" />
                    } @else {
                        <vn-icon name="theme-virtualsport" size="14" />
                    }
                }
                {{ bet().eventName }}
            </div>
            <div class="mybets-betslip-non-event-info_event-date font-small">
                {{ bet().eventDate | msMyBetsEventDatePipe }}
            </div>
        </ng-container>
    </ms-my-bets-betslip-scoreboard>
</ng-template>

<ng-template #myBetsBetSlipHeadSection>
    <ng-container [ngTemplateOutlet]="TopRightSection" />
    <div [ngClass]="{ 'mybets-betslip-single-bet-header': isSingleBetPrintPreview }">
        @if (showBetslipId()) {
            <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip().betslipId }}</span>
        }
    </div>
    <ng-container [ngTemplateOutlet]="pickInformation"></ng-container>
</ng-template>

<ng-template #pickInformation>
    <div
        class="mybets-betslip-info_pick-data clearfix"
        [ngClass]="{ 'mybets-betslip-info_pick-data--with-paddings': shouldApplyPaddings(), '.pb-0': mybetsConfig.showSportAndCompetitionName }">
        <ms-my-bets-betslip-option-name [bet]="bet()"></ms-my-bets-betslip-option-name>
        <ms-my-bets-betslip-market-name [bet]="bet()"></ms-my-bets-betslip-market-name>
        @if (bet().isBanker) {
            <div class="banker-icon">{{ sitecore.betslip.messages.BankerAbbr }}</div>
        }
    </div>
    @if (mybetsConfig.showSportAndCompetitionName) {
        <div class="mybets-betslip-info clearfix">
            <ms-my-bets-betslip-sport-competition-name [bet]="bet()" />
        </div>
    }
</ng-template>

<ng-template #TopRightSection>
    <div class="mybets-betslip-info_right-section clearfix">
        <ng-content select="[topright-section]" />
        <ng-content select="[best-odds-badge]" />
    </div>
</ng-template>
